/**
 * XSS'e yapısal önlem: DOM'a giden HER markup bu modülden geçer.
 *
 * - html`` etiketi, aradeğerlenen TÜM değerleri otomatik HTML-escape eder.
 * - İç içe html`` sonuçları (SafeHtml) olduğu gibi birleşir.
 * - raw() yalnız sabit/derleme-içi parçalar için dar bir kaçış kapısıdır;
 *   kullanıcı/API verisi ASLA raw()'a verilmez.
 *
 * Böylece güvenlik "dikkatli olmaya" değil tip sistemine dayanır:
 * SmgElement yalnız SafeHtml kabul eder.
 */

export class SafeHtml {
  constructor(readonly value: string) {}
}

export function esc(value: unknown): string {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

type HtmlValue = string | number | boolean | null | undefined | SafeHtml | HtmlValue[];

function serialize(value: HtmlValue): string {
  if (value == null || value === false || value === true) return '';
  if (value instanceof SafeHtml) return value.value;
  if (Array.isArray(value)) return value.map(serialize).join('');
  return esc(value);
}

export function html(strings: TemplateStringsArray, ...values: HtmlValue[]): SafeHtml {
  let out = '';
  for (let i = 0; i < strings.length; i++) {
    out += strings[i];
    if (i < values.length) out += serialize(values[i]);
  }
  return new SafeHtml(out);
}

/** Sabit, elle yazılmış markup için dar kaçış kapısı. Veriyle ÇAĞIRMA. */
export function raw(trustedStatic: string): SafeHtml {
  return new SafeHtml(trustedStatic);
}

/** Liste basma: her öğe için html`` üret, birleştir. */
export function each<T>(
  items: readonly T[],
  fragment: (item: T, index: number) => SafeHtml,
): SafeHtml {
  return new SafeHtml(items.map((it, i) => fragment(it, i).value).join(''));
}

/** Koşullu parça. */
export function when(cond: unknown, fragment: () => SafeHtml): SafeHtml {
  return cond ? fragment() : new SafeHtml('');
}
